import { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { SectionTitle } from "./Sections";

const BG = "https://images.unsplash.com/photo-1728895604559-a4e16081504e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const FARMER = "https://images.unsplash.com/photo-1605000797499-95a51c5269ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";
const HARVEST = "https://images.unsplash.com/photo-1659822887922-c1386185cc6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export const Testimonials = () => {
  const { t } = useTranslation();
  const items = t("testimonials.items", { returnObjects: true });
  const [idx, setIdx] = useState(0);
  const item = items[idx];

  return (
    <section className="relative py-24 overflow-hidden">
      <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-brand-dark/85" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <SectionTitle title={<span className="text-brand-yellow">{t("testimonials.title")}</span>}
          subtitle={<span className="text-white/70">{t("testimonials.subtitle")}</span>} />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <motion.div key={idx} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }}
            className="lg:col-span-7">
            <Quote size={48} className="text-brand-orange" />
            <p data-testid="testimonial-text" className="mt-4 text-white text-xl sm:text-2xl leading-relaxed font-semibold">
              "{item.text}"
            </p>
            <div className="mt-6">
              <div className="font-heading text-2xl text-brand-yellow uppercase">{item.name}</div>
              <div className="text-sm text-white/60 font-semibold">{item.location}</div>
            </div>
            <div className="mt-8 flex gap-3">
              <button data-testid="testimonial-prev" onClick={() => setIdx((idx - 1 + items.length) % items.length)}
                className="w-12 h-12 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-brand-orange transition-colors rtl:rotate-180">
                <ChevronLeft size={20} />
              </button>
              <button data-testid="testimonial-next" onClick={() => setIdx((idx + 1) % items.length)}
                className="w-12 h-12 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-brand-orange transition-colors rtl:rotate-180">
                <ChevronRight size={20} />
              </button>
            </div>
          </motion.div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-4">
            <div className="relative rounded-3xl overflow-hidden">
              <img src={FARMER} alt="before" className="w-full h-48 sm:h-64 object-cover grayscale" />
              <span className="absolute bottom-3 start-3 px-3 py-1 rounded-full bg-brand-brown text-white text-xs font-bold uppercase">
                {t("testimonials.before")}
              </span>
            </div>
            <div className="relative rounded-3xl overflow-hidden mt-8">
              <img src={HARVEST} alt="after" className="w-full h-48 sm:h-64 object-cover" />
              <span className="absolute bottom-3 start-3 px-3 py-1 rounded-full bg-brand-green text-white text-xs font-bold uppercase">
                {t("testimonials.after")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
